/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Amount } from './Amount';
import {
    instanceOfAmount,
    AmountFromJSON,
    AmountFromJSONTyped,
    AmountToJSON,
} from './Amount';
import type { Percentage } from './Percentage';
import {
    instanceOfPercentage,
    PercentageFromJSON,
    PercentageFromJSONTyped,
    PercentageToJSON,
} from './Percentage';
import type { SkipPrompt } from './SkipPrompt';
import {
    instanceOfSkipPrompt,
    SkipPromptFromJSON,
    SkipPromptFromJSONTyped,
    SkipPromptToJSON,
} from './SkipPrompt';

/**
 * @type InitiateSoftpayAppSwitchPaymentRequestTip
 * 
 * @export
 */
export type InitiateSoftpayAppSwitchPaymentRequestTip = Amount | Percentage | SkipPrompt;

export function InitiateSoftpayAppSwitchPaymentRequestTipFromJSON(json: any): InitiateSoftpayAppSwitchPaymentRequestTip {
    return InitiateSoftpayAppSwitchPaymentRequestTipFromJSONTyped(json, false);
}

export function InitiateSoftpayAppSwitchPaymentRequestTipFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateSoftpayAppSwitchPaymentRequestTip {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfAmount(json)) {
        return AmountFromJSONTyped(json, true);
    }
    if (instanceOfPercentage(json)) {
        return PercentageFromJSONTyped(json, true);
    }
    if (instanceOfSkipPrompt(json)) {
        return SkipPromptFromJSONTyped(json, true);
    }
    return {} as any;
}

export function InitiateSoftpayAppSwitchPaymentRequestTipToJSON(json: any): any {
    return InitiateSoftpayAppSwitchPaymentRequestTipToJSONTyped(json, false);
}

export function InitiateSoftpayAppSwitchPaymentRequestTipToJSONTyped(value?: InitiateSoftpayAppSwitchPaymentRequestTip | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfAmount(value)) {
        return AmountToJSON(value as Amount);
    }
    if (instanceOfPercentage(value)) {
        return PercentageToJSON(value as Percentage);
    }
    if (instanceOfSkipPrompt(value)) {
        return SkipPromptToJSON(value as SkipPrompt);
    }
    return {};
}

